import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RxApiService } from "../../../core/communication/http/rx-api.service";
import {AdminNewsItem, AdminStats, EmailTargetEntry, ListResponseData} from "../../../core/types";

@Injectable()
export class AdminService {
    constructor(
        private rxApi: RxApiService
    ) {}

    public listNews(params?: Record<string, any>): Observable<ListResponseData<AdminNewsItem>> {
        return this.rxApi.get(["admin", "news"], params || {});
    }

    public addNews(newsItem: AdminNewsItem): Observable<void> {
        return this.rxApi.post(["admin", "news"], {}, newsItem);
    }

    public updateNews(newsItem: AdminNewsItem): Observable<void> {
        return this.rxApi.patch(["admin", "news", newsItem._id], {}, newsItem);
    }

    public deleteNews(newsItem: AdminNewsItem): Observable<void> {
        return this.rxApi.remove(["admin", "news", newsItem._id]);
    }
}
